// File: src/components/ui/badge.tsx
// CTO Recovery Prompt — Minimal shadcn-style Badge component
// - No stubs: real, production-usable badge
// - Reuses existing `cn` helper from lib/utils

import * as React from "react";
import { cn } from "@/lib/utils";

export interface BadgeProps
  extends React.HTMLAttributes<HTMLDivElement> {
  variant?: "default" | "secondary" | "outline";
}

const variantClasses: Record<
  NonNullable<BadgeProps["variant"]>,
  string
> = {
  default:
    "bg-primary text-primary-foreground border-transparent",
  secondary:
    "bg-secondary text-secondary-foreground border-transparent",
  outline:
    "text-foreground border-border",
};

export const Badge: React.FC<BadgeProps> = ({
  className,
  variant = "default",
  ...props
}) => {
  const base =
    "inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs font-semibold " +
    "transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2";

  const variantClass =
    variantClasses[variant] ?? variantClasses.default;

  return (
    <div
      className={cn(base, variantClass, className)}
      {...props}
    />
  );
};

export default Badge;
